import BONGARDS from './bongards-config';
import CACIQUE from './cacique-config';
import CDI from './cdi-config';
import LEGACY from './legacy-config';
import MMPA from './mmpa-config';
import UDA from './uda-config';
import PRAIRIE from './prairie-config';
import TCJ from './tcj-config';
import TCJ_V2 from './tcj-v2-config';
import UNC from './unc-config';
import NL from './nl-config';
import USDEMO from './us-demo-config';
import DEFAULT from './default-config';
import PSC from './psc-config';
import { getUserPermissions } from './UserPermissions/user-based-permissions';
import { getUser } from '../../../../utils';
import Split from '../../../split';
import IMP from './imp-config';
import MINERVA from './minerva-config';
import PLAINVIEW from './plainview-config';
import UDI from './udi-config';

const Permissions = {
    BONGARDS,
    CACIQUE,
    CDI,
    LEGACY,
    MMPA,
    PRAIRIE,
    'TCJ-LIBERTY': TCJ,
    'TCJ-WHITEEAGLE': TCJ_V2,
    'TCJ-GPDA': TCJ_V2,
    'TCJ-ERIE': TCJ_V2,
    'TCJ-NEBRASKA': TCJ,
    'TCJ-KYTN': TCJ,
    UDA,
    UNC,
    NL,
    USDEMO,
    DEMO: USDEMO,
    PSC,
    IMP,
    MINERVA,
    PLAINVIEW,
    UDI,
};

const getPermissions = (userRole) => {
    const user = getUser();
    const regionConfig = Permissions[user.region] ?? DEFAULT;
    const roleConfig = regionConfig[userRole];
    const userPermissions = getUserPermissions(userRole);
    const requiredPermissions = (roleConfig.required ?? []).reduce((acc, p) => acc.add(p.value), new Set());
    const userPermissionValues = Array.isArray(user?.permissions) ? user.permissions : [];
    // some permissions should only be available to be toggled on/off for other users
    // if that user has the required permission themselves
    const permissionsRequiredToToggle = ['ManageBankingInfo', 'ViewMilkPredictionReport', 'ViewContractPerformanceReport', 'ViewSupplyOutlookReport'];
    const hasPermissionRequiredToToggle = (permission) => userPermissionValues.includes(permission);

    // Evaluate permissions with splits out of the list
    const evaluatedPermissions = (roleConfig.permissions ?? [])
        .map((group) => {
            let filteredPermissions = (group.permissions ?? []).filter((permission) => {
                const toggleable = !permissionsRequiredToToggle.includes(permission.value) || hasPermissionRequiredToToggle(permission.value);
                const splitEnabled = !permission.split || Split.getBooleanTreatment(permission.split);
                const mutationEnabled = !permission.enableMutationFn || permission.enableMutationFn();

                return toggleable && splitEnabled && mutationEnabled;
            });
            return filteredPermissions.length > 0 ? { ...group, permissions: filteredPermissions } : null;
        })
        .filter((group) => group !== null);

    return {
        permissionGroups: [...evaluatedPermissions, ...userPermissions],
        requiredPermissions,
        // force-wrap
    };
};

export default getPermissions;
